export function commonFunc() {
	handleSamePageAnchorLinks();
	handleCrossPagesAnchorLinks();
}

/**
 * 登場人物アンカー専用の追加オフセット（PC: -30 / SP: -20）
 *
 * @param {string} targetId
 * @returns {number}
 */
export function getCharacterAnchorAdjust(targetId) {
	if (targetId !== 'character') return 0;
	return window.matchMedia('(max-width: 1024px)').matches ? -50 : -100;
}

/**
 * ヘッダー高さを考慮したアンカー先の scrollTop を返す
 *
 * @param {Element} targetElement
 * @param {string} targetId
 * @returns {number}
 */
export function getAnchorScrollTop(targetElement, targetId) {
	const header = document.querySelector('.l-header');
	const headerHeight = header ? header.offsetHeight : 0;
	const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
	return targetPosition - headerHeight + getCharacterAnchorAdjust(targetId);
}

/**
 * href が現在ページ内のアンカーかどうかを判定
 *
 * @param {string} href
 * @returns {{ isSamePage: boolean, targetId: string } | null}
 */
function parseSamePageAnchor(href) {
	if (!href || href.indexOf('#') === -1) return null;

	let url;
	try {
		url = new URL(href, window.location.href);
	} catch (err) {
		return null;
	}

	if (url.host !== window.location.host) return null;
	if (url.pathname !== window.location.pathname) return null;

	const targetId = decodeURIComponent(url.hash.replace(/^#/, ''));
	if (!targetId) return null;

	return { isSamePage: true, targetId };
}

/**
 * アンカーリンク（同一ページ内）
 * メニュー／フッターは _smoothScroll.js 側で処理するため除外する
 */
function handleSamePageAnchorLinks() {
	function handleAnchorClick(event) {
		const target = event.target.closest('a[href*="#"]');
		if (!target) return;
		if (target.closest('.l-menu, .l-footer')) return;
		// あらすじ一覧のアンカーは pages/_story.js 側で処理
		if (target.matches('[data-story-anchor]')) return;

		const parsed = parseSamePageAnchor(target.getAttribute('href'));
		if (!parsed) return;

		const targetElement = document.getElementById(parsed.targetId);
		if (!targetElement) return;

		event.preventDefault();
		window.scrollTo({
			top: getAnchorScrollTop(targetElement, parsed.targetId),
			behavior: 'smooth',
		});
	}

	document.addEventListener('click', handleAnchorClick);
}

/**
 * アンカーリンク（ページ遷移後のハッシュ）
 */
function handleCrossPagesAnchorLinks() {
	if (!window.location.hash) return;

	const targetId = decodeURIComponent(window.location.hash.slice(1));
	const targetElement = document.getElementById(targetId);
	if (!targetElement) return;

	// ブラウザ既定のハッシュジャンプ後に、オフセット付きで位置を補正する
	const scroll = () => {
		window.scrollTo({
			top: getAnchorScrollTop(targetElement, targetId),
			behavior: 'smooth',
		});
	};

	window.setTimeout(scroll, 0);
	window.setTimeout(scroll, 100);
}
